module.exports = __webpack_public_path__ + "static/anna-karenina-93a7abcb1b6f92fc067f0910c2759cf9.jpg";